Namespace 'AccountSettings.ConversationAttributes'

class AccountSettings.ConversationAttributes.HierarchicalTag extends Backbone.Model

  defaults:
    code: ''
    description: ''
    active: true
    choosable: true
    children: []

  initialize: =>
    @setActive(@get('active'))

  get: (key) ->
    if key == 'children'
      return new AccountSettings.ConversationAttributes.HierarchicalTagCollection(super('children'))
    else
      super(key)

  pathTo: (tagCode) ->
    return [@] if @get('code') == tagCode
    children = @get('children')
    foundPath = children.pathTo(tagCode)
    children = undefined
    return [] unless foundPath.length
    [@, foundPath...]

  setActive: (active) =>
    @set('active', active)
    @get('children').setActive(active) unless active

  _validateFields: =>
    messages = []
    if _.isEmpty(@get('code'))
      messages.push(
        I18n.t('monitoring.conversation_attributes.errors.hierarchical_tags.tag_code_missing')
      )
    if _.isEmpty(@get('description'))
      messages.push(
        I18n.t('monitoring.conversation_attributes.errors.hierarchical_tags.tag_description_missing')
      )
    return {success: false, messages} unless _.isEmpty(messages)
    @get('children')._validateFields()

  _getCodes: =>
    [@get('code'), @get('children')._getCodes()...]

  _validateAllLeafsAreChoosable: =>
    isLeaf = @get('children').isEmpty()
    unchoosable = !@get('choosable')
    if isLeaf && unchoosable
      return {
        success: false,
        messages: [
            I18n.t('monitoring.conversation_attributes.errors.hierarchical_tags.unchoosable_leaf')
        ]
      }
    @get('children')._validateAllLeafsAreChoosable()

class AccountSettings.ConversationAttributes.HierarchicalTagCollection extends Backbone.Collection
  model: AccountSettings.ConversationAttributes.HierarchicalTag

  pathTo: (tagCode) =>
    @reduce(((foundPath, tag) ->
      if foundPath.length
        foundPath
      else
        tag.pathTo(tagCode)
    ), [])

  codePathTo: (tagCode) =>
    @pathTo(tagCode).map((tag) -> tag.get('code'))

  getTag: (tagCode) =>
    @pathTo(tagCode).slice(-1)[0]

  validate: =>
    @_combineResults([
      @_validateSize(),
      @_validateFields(),
      @_validateCodes(),
      @_validateAllLeafsAreChoosable(),
    ])

  setActive: (active) =>
    @forEach((tag) -> tag.setActive(active))

  _validateSize: =>
    if @size()
      {
        success: true,
        messages: []
      }
    else
      {
        success: false,
        messages: [I18n.t('monitoring.conversation_attributes.errors.hierarchical_tags.no_tag_definition')]
      }

  _validateFields: =>
    @_combineResults(@map((tag) -> tag._validateFields()))

  _validateCodes: =>
    @_areCodesUnique(@_getCodes())

  _areCodesUnique: (codes) ->
    grouped_codes = _.values(_.groupBy(codes, (code) -> code.toString()))
    grouped_repeated_codes = _.compact(_.uniq(_.flatten(_.filter(grouped_codes, (group) -> group.length > 1))))
    success = _.isEmpty(grouped_repeated_codes)
    messages = []
    unless success
      if grouped_repeated_codes.length > 1
        message = I18n.t('monitoring.conversation_attributes.errors.hierarchical_tags.repeated_codes') +
          grouped_repeated_codes.toString()
      else
        message = I18n.t('monitoring.conversation_attributes.errors.hierarchical_tags.repeated_code') +
          grouped_repeated_codes.toString()
      messages.push(message)
    {
      success
      messages
    }

  _getCodes: =>
    @reduce(((codes, tag) -> [tag._getCodes()..., codes...]), [])

  _validateAllLeafsAreChoosable: =>
    @_combineResults(@map((tag) -> tag._validateAllLeafsAreChoosable()))

  _combineResults: (results) ->
    {
      success: _.every(results, ({success}) -> success)
      messages: _.uniq(_.flatten(_.map(results, ({messages}) -> messages)))
    }
